import { Entry } from '../Entry'

export function Entry20221109() {
  return (
    <Entry title="09/11/2022 - v3.2.10">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13281/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
